import useSWR from "swr";

const fetcher = (...args) => fetch(...args).then((res) => res.json());

const CategoryDropdownL1 = ({ selectHandler, elValue}) => {
  const { data, error } = useSWR(`${process.env.REACT_APP_API_URL}/list_languages`, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  }); 
  
  if (error) {
    return <select
      className="mr-2 ml-2 text-left py-2 px-4 text-2xl bg-cyan-100 border-4 border-teal-400 text-black-500 bg-white border rounded-md 
        shadow-sm outline-none appearance-none focus:border-teal-600"
    >
      <option value="Other" key="newother">L1L2map is unavailable</option>
    </select>
  }

  if (!data) {
    return <select
      className="mr-2 ml-2 text-left py-2 px-4 text-2xl bg-cyan-100 border-4 border-teal-400 text-black-500 bg-white border rounded-md 
        shadow-sm outline-none appearance-none focus:border-teal-600"
      >
      <option value="Other" key="newother2">Loading list...</option>
    </select>
  }

  return <select
    className=" h-12 border-4 border-teal-400 rounded-md p-2 text-xl"
    onChange={selectHandler}
    value={elValue}
  >     
    {data.result&&data.result.map((lang,i) => <option value={lang.name} key={String(lang.pk)+String(i)}>
      {lang.name}
    </option>)}
  </select>

};


export default CategoryDropdownL1;
